import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Connection Api Service
 */
const ConnectionApiService = {

  getData: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_CONNECTION_LIST

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          url += `?userAccountId=${selectedAccount}`
        }

        if (parseToJson['userId']) {
          url += `&userId=${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching data`, err)
    }
  },

  getAllLogsList: async (selectedAccount, connectionId) => {
    try {
      let url = APIConstants.ENDPOINT_LOGS_LIST

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (connectionId) {
        url += `&connectionId=${connectionId}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching data`, err)
    }
  },

  saveData: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_ADD_CONNECTION

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error caught while saving data`, err)
    }
  },

  getServiceList: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_CONNECTION_SERVICE_LIST

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          url += `?userAccountId=${selectedAccount}`
        }

        if (parseToJson['userId']) {
          url += `&userId=${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching data`, err)
    }
  },

  deployService: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_DEPLOY_SERVICE

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error caught while deploying service`, err)
    }
  },

  getDeployServiceLogs: async (selectedAccount, jobID) => {
    try {
      let url = APIConstants.ENDPOINT_DEPLOY_SERVICE_LOGS

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (jobID) {
        url += `&jobId=${jobID}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching logs for deployed service`, jobID, err)
    }
  },

  executeCommand: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_EXECUTE_COMMAND

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error caught while initiating command execution`, err)
    }
  },

  getExecuteCommandLogs: async (selectedAccount, jobID) => {
    try {
      let url = APIConstants.ENDPOINT_EXECUTE_COMMAND_LOGS

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (jobID) {
        url += `&jobId=${jobID}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching logs for command execution`, jobID, err)
    }
  },

  getMonitoringList: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_DEVOPS_MONITORING_LIST

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          url += `?userAccountId=${selectedAccount}`
        }

        if (parseToJson['userId']) {
          url += `&userId=${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Connection Api Service: Error Caught while fetching monitoring data`, err)
    }
  },
}

export default ConnectionApiService;
